const axios = require('axios');
module.exports.init = me => {
  me.sendDownloadEmail = function () {
    let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let on_success = arguments.length > 1 ? arguments[1] : undefined;
    let on_failure = arguments.length > 2 ? arguments[2] : undefined;
    axios.post(`${me.config.url}/request-demo/send-mail`, data, {
      ...me.globalheaders
    }).then(response => {
      const {
        data
      } = response.data;
      on_success(data);
    }).catch(response => {
      on_failure(response);
    });
  };
  me.subscribeNewsLetter = function () {
    let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let on_success = arguments.length > 1 ? arguments[1] : undefined;
    let on_failure = arguments.length > 2 ? arguments[2] : undefined;
    axios.post(`${me.config.url}/subscribe-news-letter`, data, {
      ...me.globalheaders
    }).then(response => {
      const {
        data
      } = response.data;
      on_success(data);
    }).catch(response => {
      on_failure(response);
    });
  };
  me.getStaticValue = function () {
    let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let on_success = arguments.length > 1 ? arguments[1] : undefined;
    let on_failure = arguments.length > 2 ? arguments[2] : undefined;
    axios.post(`${me.config.url}/static-values/search`, data, {
      ...me.globalheaders
    }).then(response => {
      const {
        data
      } = response.data;
      on_success(data);
    }).catch(response => {
      on_failure(response.message);
    });
  };
  me.contactUs = function () {
    let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let on_success = arguments.length > 1 ? arguments[1] : undefined;
    let on_failure = arguments.length > 2 ? arguments[2] : undefined;
    axios.post(`${me.config.url}/contact-us`, data, {
      ...me.globalheaders
    }).then(response => {
      const {
        data
      } = response.data;
      on_success(data);
    }).catch(response => {
      on_failure(response);
    });
  };
};